<template>
    <div class="card"
        :class="{
            '--flipped': isFlipped,
            '--deg15'  : isDeg15,
            '--zoom'   : isZoomed,
        }"
        @click="onClick"
        :data-card="slug"
    >
        <div class="card__wrapper">         
            <div class="card__recto">
                <card-image :slug="slug"/>
            </div>
            <div class="card__verso">
                <card-image slug="verso"/>
            </div>
        </div>
    </div>
</template>

<script>
    import CardImage from './CardImage'

    export default {
        components: {CardImage},
        props: {
            slug: {type: String, required: true},
            flipped: {type: Boolean, default: false},
            zoomed: {type: Boolean, default: false},
            deg15: {type: Boolean, default: false},
        },
        data () {return {
            isFlipped: this.flipped,
            isZoomed: this.zoomed,
            isDeg15: this.deg15,
        }},
        methods: {
            flip () {
                this.isFlipped = !this.isFlipped;
            },
            onClick (event) {
                this.$emit('click', this, event);
            },
            toggleZoom () {
                this.isZoomed = !this.isZoomed;
            },
            toggleDeg15 () {
                this.isDeg15 = !this.isDeg15;
            },
        }
    }
</script>